const DEVTOOLS_OMITTED = '<<OMITTED>>';

type DevtoolsSanitizedState = {
    gameWindows: Window[];
    embeddedGame: {
        iframeRef: HTMLIFrameElement | null;
    };
};

/** Strip non-serializable DOM refs before Redux DevTools snapshots. */
export const sanitizeStoreStateForDevtools = <T extends DevtoolsSanitizedState>(state: T): T => {
    const omitGameWindows = Boolean(state.gameWindows);
    const omitIframeRef = state.embeddedGame.iframeRef !== null;

    if (!omitGameWindows && !omitIframeRef) {
        return state;
    }

    return {
        ...state,
        ...(omitGameWindows ? { gameWindows: DEVTOOLS_OMITTED as unknown as T['gameWindows'] } : {}),
        ...(omitIframeRef
            ? {
                  embeddedGame: {
                      ...state.embeddedGame,
                      iframeRef: DEVTOOLS_OMITTED as unknown as T['embeddedGame']['iframeRef']
                  }
              }
            : {})
    };
};
